import React, { FC } from 'react';
import { IconButton } from '../../../../../components/IconButton';

type PublicJobDetailShareButton = {
	onClick: () => unknown;
	children: JSX.Element;
};

export const PublicJobDetailShareButton: FC<React.PropsWithChildren<PublicJobDetailShareButton>> = ({
	onClick,
	children,
}) => {
	return (
		<IconButton
			onClick={onClick}
			link
			rounded
			size='small'
			forceSize
		>
			{children}
		</IconButton>
	);
};
